<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon class="bright" points="11,6 6,2 6,5 1,5 1,7 6,7 6,10" />
</svg>
</template>